export default __webpack_public_path__ + "static/media/logo.25b95e87.png";